function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSchlankboosterThin = function SvgSchlankboosterThin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.996,
    height: 32,
    viewBox: "0 0 31.996 32",
    style: {
      fill: "none"
    }
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    style: {
      strokeWidth: 1.4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 34.04299927,
      strokeDasharray: "none",
      strokeOpacity: 1,
      fill: "none"
    },
    d: "M9.176-11.314s1.72 1.72 1.72 6.879c0 6.02-5.16 6.88-5.16 13.759a7.53 7.53 0 0 0 1.72 5.16m17.197-25.798s-1.719 1.72-1.719 6.879c0 6.02 5.16 6.88 5.16 13.759a7.53 7.53 0 0 1-1.721 5.16M4.017-7.876l2.832 2.833a.857.857 0 0 1 0 1.214L4.017-.994m25.795-6.88-2.83 2.832a.857.857 0 0 0 0 1.215l2.83 2.833M16.914 14.483v-3.44m0 0-2.579-2.58m2.58 2.58 2.58-2.58",
    strokeMiterlimit: 34.043,
    transform: "translate(-.917 14.414)"
  }));
};
export default SvgSchlankboosterThin;